import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import MyRouter from "./router/MyRouter";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<MyRouter />);
